import { render, staticRenderFns } from "./custom-rule-form.vue?vue&type=template&id=060269b7&scoped=true"
import script from "./custom-rule-form.vue?vue&type=script&lang=ts"
export * from "./custom-rule-form.vue?vue&type=script&lang=ts"
import style0 from "./custom-rule-form.vue?vue&type=style&index=0&id=060269b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060269b7",
  null
  
)

export default component.exports